import { render, staticRenderFns } from "./videoorder.vue?vue&type=template&id=6e2f0f15&scoped=true"
import script from "./videoorder.vue?vue&type=script&lang=js"
export * from "./videoorder.vue?vue&type=script&lang=js"
import style0 from "./videoorder.vue?vue&type=style&index=0&id=6e2f0f15&prod&lang=scss&scoped=true"
import style1 from "./videoorder.vue?vue&type=style&index=1&id=6e2f0f15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f0f15",
  null
  
)

export default component.exports